import React, {useEffect, useState} from "react";
import BlogImagePopper from "./BlogImageLarge";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import image36 from "../../../../assets/images/blog24/blog24-36.png";
import image6 from "../../../../assets/images/blog24/blog24-6.png";
import image1 from "../../../../assets/images/blog24/blog24-1.png";
import image21 from "../../../../assets/images/blog24/blog24-21.png";
import image17 from "../../../../assets/images/blog24/blog24-17.png";
import image30 from "../../../../assets/images/blog24/blog24-30.png";
import image31 from "../../../../assets/images/blog24/blog24-31.png";
import image3 from "../../../../assets/images/blog24/blog24-3.png";
import image28 from "../../../../assets/images/blog24/blog24-28.png";
import image12 from "../../../../assets/images/blog24/blog24-12.png";
import image34 from "../../../../assets/images/blog24/blog24-34.png";
import image23 from "../../../../assets/images/blog24/blog24-23.png";
import image25 from "../../../../assets/images/blog24/blog24-25.png";
import image37 from "../../../../assets/images/blog24/blog24-37.png";
import image20 from "../../../../assets/images/blog24/blog24-20.png";
import image9 from "../../../../assets/images/blog24/blog24-9.png";

const Blog24 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – June 23, 2025</h2>
      </div>
      <div className="blogContentnew">
        <p>Geopolitics, Gamma, and a Grind Higher: Markets Lean In, But Summer Risks Linger</p>
        <p>
          Markets enter the week walking a tightrope between macro fear and positioning momentum. The Iran strike, looming tariffs, and Q2 earnings risk all swirl into a cocktail of “risk-aware”
          rallying.
        </p>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: “The Only Certainty is Uncertainty”</p>
              <p>
                Markets ended last week with a bang: a huge buy program into Quad Witching close, followed by an apparent U.S. strike on Iran’s nuclear sites. You’d expect chaos. Instead? Futures
                yawned, oil popped and faded, and equities held flat.
              </p>
              <p>That’s your signal: this is a market looking through geopolitical drama, for now.</p>
              <p>
                We’re hovering just 3% from SPX all-time highs, with the gamma flip at 5931 SPX defended overnight. Oil spikes and dollar dips aren’t triggering panic. But the setup says the rally
                from April lows could be topping out soon, with a proper summer consolidation to follow.
              </p>
            </div>
            <div className="contentDiv listOfRecap">
              <p
                style={{
                  textAlign: "justify",
                  fontFamily: "var(--header-font-family)",
                  fontSize: "18px",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "30px",
                  color: "#010310",
                }}
              >
                Key Sentiment Signals:
              </p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>No VIX spike despite Middle East escalation</p>
                </li>
                <li className="themesPointer">
                  <p>Record equity inflows: $45B in 4 weeks, $360B annualised</p>
                </li>
                <li className="themesPointer">
                  <p>Dollar near consensus exhaustion zone (~DXY 95-96)</p>
                </li>
                <li className="themesPointer">
                  <p>July seasonality is strong, but end-of-June is weak historically</p>
                </li>
                <li className="themesPointer">
                  <p>Buybacks paused, leaving equities vulnerable to earnings volatility</p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image36}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image36)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image6}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image6)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image1}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image1)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv">
              <p className="highlightedBoldText">Macro & Policy Watch: Tariffs, Central Banks, and the Middle East Wildcard</p>
            </div>
            <p
              style={{
                textAlign: "justify",
                fontFamily: "var(--header-font-family)",
                fontSize: "18px",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "30px",
                color: "#010310",
              }}
            >
              Iran Tensions: “Targeted, Swift, and Market-Tolerated”
            </p>
            <p>
              Reports confirmed U.S. action against Iranian enrichment facilities. Tehran has threatened to close the Strait of Hormuz, and analyst are already whispering $120+ oil. But for now,
              markets see it as containable, not escalating.
            </p>

            <div className="imageWrapperCont">
              <div className="relatedImg">
                <img
                  src={image21}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image21)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <div className="relatedImg">
                <img
                  src={image17}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image17)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
            <p>
              The real macro swing factor? July 9th U.S. tariff deadline. Traders expect volatility and possible resolution, but even a temporary “Trump solution” may not calm supply chains overnight.
            </p>

            <p
              style={{
                textAlign: "justify",
                fontFamily: "var(--header-font-family)",
                fontSize: "18px",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "30px",
                color: "#010310",
              }}
            >
              Central Banks: Dovish Drift Without a Fed Put
            </p>
            <div className="contactDiv listOfRecap">
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">FOMC :</span> Held rates, but raised inflation forecast to 3% for 2025. No help here.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">BoE :</span> No change, but a 6–3 split hints at August cut odds rising.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">SNB and Sweden: </span>Cut rates, citing falling inflation and weak growth.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">Fed speakers: </span>Split between “ready to cut” (Waller) and “stand firm” (Barkin).
                  </p>
                </li>
              </ul>
              <p>Powell stays cautious, citing the tariff's impact on inflation.</p>
            </div>
            <div className="imageWrapperCont">
              <div className="relatedImg">
                <img
                  src={image30}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image30)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <div className="relatedImg">
                <img
                  src={image31}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image31)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
            <p>Meanwhile, the euro is benefiting from capital flows as Lagarde pushes “Europe’s moment” and deflation hits producer prices across the region. China’s export deflation adds fuel.</p>
            <div className="relatedImg">
              <img
                src={image3}
                alt=""
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(image3)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Setups</p>
              <p>
                Markets are walking the line between breakout optimism and geopolitical dread. The SPX defended its key <span className="highlightedText"> gamma flip level at 5931,</span> which
                corresponds with expiry pivots around <span className="highlightedText">ES 5985.</span> This area remains critical—breaching it could trigger dealer-driven selling, while holding above
                supports a grind higher.
              </p>
              <p>
                From a wave structure view, the move off the<span className="highlightedText"> April “Liberation lows”</span> appears to be in a potential
                <span className="highlightedText">equal-legs extended wave 4</span> consolidation. That implies near-term choppiness before a proper summer breakout.
              </p>
              <p>
                Meanwhile, <span className="highlightedText">precious metals</span> remain stealth leaders. Despite geopolitical risk, gold and silver haven’t exploded—but the technicals say “stay
                ready.”
              </p>
            </div>
            <div className="contentDiv listOfRecap">
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold:</span> Best-performing asset class YTD. Inflows topped $2.8B last week—the biggest in 8 weeks. Wealth clients are still underweight (~0.4%
                    AuM), suggesting plenty of room to run.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">Silver:</span> Breaking into a 12-year cup & handle pattern—technical bulls watching closely.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">Dollar:</span> Hovering near consensus oversold territory. DXY in the 95–96 zone could trigger a cathartic reversal. A breakdown would support
                    further gold upside.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">Sectors to watch:</span> Airlines, travel (oil-sensitive) may lag temporarily, but this may not last.
                  </p>
                </li>
              </ul>
              <p
                style={{
                  textAlign: "justify",
                  fontFamily: "var(--header-font-family)",
                  fontSize: "18px",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "30px",
                  color: "#010310",
                }}
              >
                Key Setups:
              </p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>SPX: Defended gamma flip at 5931.</p>
                </li>
                <li className="themesPointer">
                  <p>ES futures expiry magnet at 5985.</p>
                </li>
                <li className="themesPointer">
                  <p>Silver: Cup & handle in progress.</p>
                </li>
                <li className="themesPointer">
                  <p>Gold: Inflows rising, under-ownership persists.</p>
                </li>
                <li className="themesPointer">
                  <p>DXY: Nearing flush zone at 95–96.</p>
                </li>
              </ul>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image28}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image28)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image12}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image12)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image34}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image34)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week in Review: Strikes, Soft Data, and Flow Frenzies</p>
              <p>Markets were shaken—but not stirred—by last week’s headlines:</p>
            </div>
            <div className="contentDiv listOfRecap">
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">Geopolitics:</span> U.S. hit Iranian nuclear sites. Iran threatened Hormuz closure. Oil spiked, then faded.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">Retail & Housing Data:</span> U.S. Retail Sales missed but Control group (GDP feed) solid, housing starts plunged nearly 10%, and NAHB sentiment
                    hit decade lows in the South.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Fed: </span>
                    Dovish tone but hawkish SEP. No rate cuts until inflation falls.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">Flows:</span> U.S. equity inflows remain strong; EM debt saw its second-largest weekly inflow ever ($4.8B).
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">China:</span> Export crash in rare earths (magnets down 76% YoY). Retail sales surged following Dragon Boat Festival subsidies..
                  </p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image23}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image23)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image25}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image25)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image37}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image37)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: Central Bank Parade, Macro Minefields, and Market Crossroads</p>
              <p>This week features a heavy calendar of central bank speakers and macro prints, just as markets hover near key resistance.</p>

              <p className="highlightedText">Monday, June 23</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Global PMIs</p>
                </li>
                <li className="themesPointer">
                  <p>U.S. Existing Home Sales</p>
                </li>
                <li className="themesPointer">
                  <p>Multiple Fed and ECB speakers</p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, June 24</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Germany IFO</p>
                </li>
                <li className="themesPointer">
                  <p>Canada CPI</p>
                </li>
                <li className="themesPointer">
                  <p>U.S. Conference Board Consumer Confidence</p>
                </li>
                <li className="themesPointer">
                  <p>Fed Chair Powell speaks</p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, June 25</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>U.S. New Home Sales</p>
                </li>
                <li className="themesPointer">
                  <p>Eurozone and UK car registrations (auto sector readthrough)</p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, June 26</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>U.S. Q1 Final GDP</p>
                </li>
                <li className="themesPointer">
                  <p>Durable Goods</p>
                </li>
                <li className="themesPointer">
                  <p>Pending Home Sales</p>
                </li>
                <li className="themesPointer">
                  <p>Canada Wholesale Trade</p>
                </li>
                <li className="themesPointer">
                  <p>Fed & ECB speeches</p>
                </li>
              </ul>

              <p className="highlightedText">Friday, June 27</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>U.S. PCE, Personal Income & Spending</p>
                </li>
                <li className="themesPointer">
                  <p>UoM Confidence Surveys</p>
                </li>
                <li className="themesPointer">
                  <p>JPY CPI</p>
                </li>
                <li className="themesPointer">
                  <p>Eurozone Inflation & Business Surveys</p>
                </li>
              </ul>
              <p>
                This data-heavy week will likely set the tone for the July 4th holiday stretch and tariff deadline. Expect volatility. Traders should be ready to fade extremes, especially if macro
                beats or misses collide with geopolitical shifts.
              </p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: Tactical Over Bold—For Now</p>
              <p>The market is holding up remarkably well, but don’t mistake resilience for immunity. The backdrop suggests the following:</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">Consolidation likely:</span> Extended wave 4 patterns imply we’re due for digestion after this rally
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Geopolitical flare-ups</span> are headline-sensitive but not yet trend-breaking
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Tariffs are the real landmine—</span>watch July 9th
                  </p>
                </li>
                <li className="themesPointer">
                  <p className="highlightedText">Dollar washout + gold buying = ongoing de-dollarisation story</p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Buy dips—but not just any dip. </span>Pick your spots around macro inflexion levels.
                  </p>
                </li>
              </ul>
              <p>Stay nimble. The next move could come from a Powell slip, a Hormuz flare-up, or a tariff headline at 2 a.m.</p>
            </div>
            <div className="imageWrapperCont">
              <div className="relatedImg">
                <img
                  src={image20}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image20)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <div className="relatedImg">
                <img
                  src={image9}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image9)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/14Kvk1fJLBmQyaYzxnNFti0vvYvTfHSWHgKj2yU1Uwh8/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog24;
